// Minimal hash router. Routes are plain strings (e.g. "dashboard",
// "connector/run"). Keeping it hash-based means the built app is a set of
// static files deployable to any host with no server rewrite rules.

function parse() {
  const h = window.location.hash.replace(/^#\/?/, '').trim();
  const [route = 'login', query = ''] = (h || 'login').split('?');
  return { route, params: Object.fromEntries(new URLSearchParams(query)) };
}

export const nav = $state(parse());

window.addEventListener('hashchange', () => {
  Object.assign(nav, parse());
  window.scrollTo(0, 0);
});

export function go(route, params = null) {
  const query = params ? new URLSearchParams(Object.entries(params).filter(([, value]) => value != null)).toString() : '';
  window.location.hash = '#/' + route + (query ? `?${query}` : '');
}

export const withSource = (route, sourceId) => sourceId ? `${route}?source=${encodeURIComponent(sourceId)}` : route;
